import { passwordRules } from '@src/utilities/passwordValidation';
import { CloseCircle, TickCircle } from 'iconsax-react';

type PasswordRulesProps = {
  password: string;
  t: (key: string) => string;
};

export function PasswordRules({ password, t }: PasswordRulesProps) {
  return (
    <ul className='space-y-2'>
      {passwordRules.map((rule) => (
        <li key={rule.key}>
          <span
            className={`flex flex-row gap-1 transition-colors duration-500  ${rule.test(password) ? 'text-green-500' : 'text-red-500'}`}
          >
            {rule.test(password) ? (
              <TickCircle variant='Bulk' />
            ) : (
              <CloseCircle variant='Bulk' />
            )}
            {t(rule.key)}
          </span>
        </li>
      ))}
    </ul>
  );
}
